import { toast } from "bulma-toast"

export const primitiveArrayEquals = (a: any[], b: any[]): boolean => {

    if (a === undefined && b === undefined) return true
    else if (a?.length !== b?.length) return false
    else return a?.every((val, index) => val === b[index])
}

export const copyToClipboard = async (text: string) => {
    try {
        await navigator.clipboard.writeText(text)

        toast({
            message: `Copied to clipboard`,
            type: 'is-info',
            position: 'bottom-right',
        })
    
    } catch (error) {
        // Fallback for browsers that don't support clipboard.writeText

        const textarea = document.createElement('textarea')
        textarea.value = text

        // Keep it out of view and non-interactive
        textarea.style.position = 'fixed'
        textarea.style.top = '-9999px'
        textarea.style.left = '-9999px'
        textarea.style.opacity = '0'
        textarea.style.pointerEvents = 'none'
        textarea.setAttribute('readonly', '')
        textarea.setAttribute('aria-hidden', 'true')

        document.body.appendChild(textarea)
        textarea.focus()
        textarea.select()
        document.execCommand('copy')
        document.body.removeChild(textarea)

        toast({
            message: `Copied to clipboard`,
            type: 'is-info',
            position: 'bottom-right',
        })
    }
}
